const GUTTERS_MAP = {
  sm: 'var(--grid-gutter-sm)',
  md: 'var(--grid-gutter-md)',
  lg: 'var(--grid-gutter-lg)',
  xl: 'var(--grid-gutter-xl)',
  xxl: 'var(--grid-gutter-xxl)'
}

export default GUTTERS_MAP
